import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { BusinessRuleBase } from '../../business/BusinessBase';
import { GenericValidation } from '../../../../../../../validations/GenericValidation';

const {
  formField: { principalState },
} = loanFormModel;

export class PrincipalStateValidation implements ValidationSchema {
  public name = principalState.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalState.requiredErrorMsg,
    value: principalState.required,
  };
  public nullable = true;

  public when(schema: any, context: any) {
    const bl = new BusinessRuleBase(context.parent);
    if (bl.isPrincipal() && !bl.isTrust())
      return schema.required(principalState.requiredErrorMsg);

    return GenericValidation.create({
      nullable: true,
      required: false,
    });
  }
}
export default new Validation(new PrincipalStateValidation());
